// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"478a3867","488":"c9b8f12e","732":"3bf2fb73","977":"ab356529"}[chunkId] + ".chunk.js";
};